import styled from '@themes/theme'

export const CarouselWrap = styled.div`
  display: block;
  width: 100%;

  // swiper common style
  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    height: auto;
    /* Fix of Webkit flickering */
    z-index: 1;
  }
  .swiper-container-vertical > .swiper-wrapper {
    flex-direction: column;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    //height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-container-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-container-multirow > .swiper-wrapper {
    flex-wrap: wrap;
  }
  .swiper-container-multirow-column > .swiper-wrapper {
    flex-wrap: wrap;
    flex-direction: column;
  }
  .swiper-container-free-mode > .swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    position: relative;
    transition-property: transform;
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
  /* CSS Mode */
  .swiper-container-css-mode {
    > .swiper-wrapper {
      overflow: auto;
      scrollbar-width: none; /* For Firefox */
      -ms-overflow-style: none; /* For Internet Explorer and Edge */
      &::-webkit-scrollbar {
        display: none;
      }
    }
    > .swiper-wrapper > .swiper-slide {
      scroll-snap-align: start start;
    }
  }
  .swiper-container-horizontal.swiper-container-css-mode {
    > .swiper-wrapper {
      scroll-snap-type: x mandatory;
    }
  }
  .swiper-container-vertical.swiper-container-css-mode {
    > .swiper-wrapper {
      scroll-snap-type: y mandatory;
    }
  }
   //navigation
   .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    width: calc(44px / 44 * 27);
    height: 44px;
    margin-top: calc(-1 * 44px / 2);
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: blue;
    &.swiper-button-disabled {
      opacity: 0.1;
      cursor: auto;
      pointer-events: none;
    }
    &:after {
      font-family: swiper-icons;
      font-size: 44px;
      text-transform: none !important;
      letter-spacing: 0;
      text-transform: none;
      font-variant: initial;
      line-height: 1;
    }
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    &:after {
      content: 'prev';
    }
    left: 10px;
    right: auto;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    &:after {
      content: 'next';
    }
    right: 10px;
    left: auto;
  }
  .swiper-button-lock {
    display: none;
  }
   // pagination
   .swiper-pagination {
    z-index: 10;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    bottom: 4px;
    right: 14px;
    //min-width: 48px;
    //height: 22px;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    &.swiper-pagination-hidden {
      opacity: 0;
    }
    &, * {
      color: ${props=>props.theme.color.modalgray};
    }
    .swiper-pagination-current {
      margin-right: 1px;
      color: ${props=>props.theme.color.themeTxt};
    }
    .swiper-pagination-total {
      margin-left: 1px;
    }
  }
  /* Common Styles */
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 10px;
    left: 0;
    width: 100%;
  }

 // //////////// my-style
  position: relative;
   img {
    width: 100%;
    height: auto;
  }
  // 배너 pagination
  .fraction-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px 4px;
    background: rgba(121, 136, 151, .8);
    border-radius: 5px;
    &, .swiper-pagination-current, .swiper-pagination-total {
      color: ${props=>props.theme.color.modalTxt};
      font-weight: ${props=>props.theme.fontW.medium};
      vertical-align: middle;
    }
    .arrow-ico {
      position: relative;
      transform: rotate(-45deg);
      width: 6px;
      height: 6px;
      margin-left: 6px;
      &::before, &::after {
        content:'';
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        background: ${props=>props.theme.color.mainColor};
      }
      &::before {
        width: 100%;
        height: 1px;
      }
      &::after {
        width: 1px;
        height: 100%;
      }
    }
  }
  &.home-banner {
    width: auto;
    height: auto;
    .swiper-slide {
      padding: 0 18px;
    }
    .more-btn {
      z-index: 1;
      position: absolute;
      bottom: 0;
      right: 18px;
      .txt-wrap {
        visibility: hidden;
      }
    }
    .banner-btn {
      width: 100%;
      min-height: 77px;
      border-radius: 4px;
      overflow: hidden;
    }
    .swiper-pagination.swiper-pagination-fraction {
      right: 27px;
      left: initial;
      width: auto;
    }
    .swiper-button-prev, .swiper-button-next {
      display: none;
    }
    &.pc {
      width: 511px;
      margin: 0;
      .more-btn {
        right: 117px;
        bottom: 6px;
        height: auto;
        width: auto;
        padding: 6px 9px;
        background: #506070;
        border-radius: 6px;
        .txt-wrap {
          visibility: initial;
        }
      }
      .banner-btn {
        min-height: 112px;
      }
      .swiper-slide {
       margin-bottom: 45px;
      }
      .swiper-pagination {
        bottom: 6px;
        right: 9px;
        .fraction-wrap {
          background: none;
          &, .swiper-pagination-current, .swiper-pagination-total {
            color: ${props=>props.theme.color.themeTxt};
          }
        }
      }
      .swiper-button-prev, .swiper-button-next {
        z-index: 11;
        display: block;
        top: initial;
        bottom: 5px;
        height: 30px;
        background: none;
      }
      .swiper-button-prev {
        left: initial;
        right: 81px;
        &::before, &::after {
          content: '';
          display: block;
          position:absolute;
          top: 10px;
          left: 7px;
          width: 12px;
          height: 3px;
          border-radius: 10px;
          background: ${props => props.theme.color.modalBg};
          transform: rotate(135deg);
        }
        &::after {
          top: initial;
          bottom: 10px;
          transform: rotate(45deg);
        }
      }
      .swiper-button-next {
        right: 19px;
        &::before, &::after {
          content: '';
          display: block;
          position:absolute;
          top: 10px;
          right: 7px;
          width: 12px;
          height: 3px;
          border-radius: 10px;
          background: ${props => props.theme.color.modalBg};
          transform: rotate(-135deg);
        }
        &::after {
          top: initial;
          bottom: 10px;
          transform: rotate(-45deg);
        }
      }
      &, * {
        font-size: ${props=>props.theme.font.large};
      }
      .swiper-pagination.swiper-pagination-fraction {
        width: 97px;
        height: 32px;
      }
    }
  }
`
